import { EVENT_KEY, TRACKING_ACTION } from 'src/config/tracking/index.js'
import trackingUtils from 'src/config/services/countlyTracking/utils.js'

const cloudTracking = {
  trackCloud (entity = 'cloud', result = 'SUCCESS', failedReason = null) {
    const start = {
      upload: ({ type }) => {
        const action = {
          file: TRACKING_ACTION.UPLOAD,
          folder: TRACKING_ACTION.CREATE_FOLDER,
          'cloud-file': TRACKING_ACTION.CREATE_CLOUD_FILE
        }
        return trackingUtils.track(EVENT_KEY.CLOUD.START, { action: action[type], entity })
      }
    }
    const end = {
      createFolder: ({ trackGlobal = null }) => trackingUtils.trackWithResult(EVENT_KEY.CLOUD.END, { action: TRACKING_ACTION.CREATE_FOLDER, entity, result, failedReason, trackGlobal }),
      createFile: ({ fileType }) => trackingUtils.trackWithResult(EVENT_KEY.CLOUD.END, { action: TRACKING_ACTION.CREATE_CLOUD_FILE, entity, fileType, result, failedReason }),
      upload: ({ fileCount, totalFileSizeKB, trackGlobal = null }) => trackingUtils.trackWithResult(EVENT_KEY.CLOUD.END, { action: TRACKING_ACTION.UPLOAD, entity, fileCount, totalFileSizeKB, result, failedReason, trackGlobal })
    }
    return {
      start,
      end
    }
  }
}

export default cloudTracking
